import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class OptimizationService {
  constructor(private http: HttpClient) {}

  public getOptimizedRoutes(params?: any) {
    let httpParams = new HttpParams()

    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key].toString())
        }
      })
    }

    return this.http.post(
      environment.planifyApiUrl + '/interventions/get-optimization-results',
      {},
      { params: httpParams }
    )
  }

  public deleteOptimizationResult(technicianId: number, date: string) {
    return this.http.delete(
      environment.planifyApiUrl + '/interventions/delete-optimization-result',
      {
        params: new HttpParams()
          .set('technician_id', technicianId.toString())
          .set('date', date),
      }
    )
  }
}
